import {BACKEND} from "./configuration"

/* Request Creation */

export function buildUrl(urlFragment) {
    return BACKEND.protocol + "://" + BACKEND.hostname + ":" + BACKEND.port + "/" + BACKEND.basePath + urlFragment;
}

export function formatParam(param) {
    return encodeURIComponent(param ?? "");
}

/* Response Handling */

const HTTP_STATUS_SUCCESS = 200;

const MSG_ERROR_OCCURED = "Es ist ein Fehler aufgetreten: "

export async function handleResponse(promise, onSuccess, showMessage) {
    let body = null;
    try { 

        const response = await promise;
        if(response.status === HTTP_STATUS_SUCCESS) {
            let contentType = response.headers.get("content-type");
            if(contentType == "application/json") {
                body = await response.json()
            }
            else if(contentType == "application/pdf") {
                body = await response.blob()
            }
            else if(contentType == "text/plain;charset=UTF-8") {
                body = await response.text()
            } 
            onSuccess(body)
        } 
        else {     
            showMessage(MSG_ERROR_OCCURED + response.status) 
        } 
    }catch(e) {  
        showMessage(e.toString());
    } 
    return body;
}  

export async function handleValidationResponse(promise, onSuccess, onFailure, showMessage) {
    let body = null;
    try { 
        const response = await promise;
        if(response.status === HTTP_STATUS_SUCCESS) {
            if(response.headers.get("content-type") == "application/json") {
                body = await response.json()
            }
            else if(response.headers.get("content-type") == "text/plain;charset=UTF-8") {
                body = await response.text()
            }
            onSuccess(body)
        } 
        else {     
            showMessage(MSG_ERROR_OCCURED + response.status) 
            onFailure();
        } 
    }catch(e) {  
        showMessage(e.toString());
        onFailure();
    } 
    return body;
}  